import React from 'react'
import { useState, useRef } from 'react';

export default function FramePlayer(props) {

    const [currentFrame, setCurrentFrame] = useState(1);
    const currentFrameRef = useRef(currentFrame);
    const [isEnded, setEnded] = useState(false);
    const frameNumber = props.frameNumber;
    const fps = props.fps || 24;
    const initialDelay = props.initialDelay || 0;
    const onEnd = props.onEnd || (() => { });
    const onKeyFrame = props.onKeyFrame || (() => { });
    const keyFrame = props.keyFrame
    const loop = props.loop || false;
    const ext = props.ext || "png";
    const [isPaused, setPaused] = useState(false);
    const isPausedRef = useRef(isPaused);
    const resetSignal = props.resetSignal || false;

    function animateFrame() {
        if (currentFrameRef.current < frameNumber) {
            currentFrameRef.current = isPausedRef.current ? currentFrameRef.current : currentFrameRef.current + 1;
            setCurrentFrame(currentFrameRef.current);
            setTimeout(() => {
                animateFrame();
            }, 1000 / fps);
            if (keyFrame && currentFrameRef.current === keyFrame) {
                onKeyFrame();
            }
        } else if (loop) {
            currentFrameRef.current = 1;
            setCurrentFrame(currentFrameRef.current);
            setTimeout(() => {
                animateFrame();
            }, 1000 / fps);
        } else {
            setEnded(true);
            //Needed if reset is called after the animation has ended
            setTimeout(() => {
                animateFrame();
            }, 1000 / fps);
        }
    }

    React.useEffect(() => {
        isPausedRef.current = props.paused;
    }, [props.paused]);

    React.useEffect(() => {
        console.log('launched');
        setTimeout(() => {
            animateFrame();
        }, initialDelay);
    }, []);

    React.useEffect(() => {
        if (isEnded) {
            onEnd();
        }
    }, [isEnded]);

    React.useEffect(() => {
        if (resetSignal) {
            currentFrameRef.current = 1;
            setCurrentFrame(currentFrameRef.current);
            setEnded(false);
        }
    }, [resetSignal]);

    return (
        <div className="framePlayer" >
            <img 
            src={process.env.PUBLIC_URL + "/assets/frames/" + props.dirName + "/" + currentFrame + "." + ext}
             alt="frame"
             style={{position: 'absolute', top: '0px', left: '0px', ...props.style}}
             className={props.className} />
        </div >
    )
}
